/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const TRIGGER = {
  TEAMS: 'teams',
  VISITS: 'ctmsVisits',
  MILESTONES: 'ctmsMilestones'
} as const

export const MAX_SELECTION_ALLOWED = 10
